export const ConsentStatusType = {
  LEGAL_TERMS: 'LEGAL_TERMS',
  LEGAL_TERMS_COMPANY: 'LEGAL_TERMS_COMPANY',
  SERVICE_USAGE_AGREEMENT: 'SERVICE_USAGE_AGREEMENT',
  PRICE_LIST: 'PRICE_LIST',
} as const;

export type ConsentStatusType = (typeof ConsentStatusType)[keyof typeof ConsentStatusType];
